/** US fluid ounces to milliliters (exact definition used for nutrition labels: 1 fl oz = 29.5735295625 ml). */
export const ML_PER_US_FLOZ = 29.5735295625;

export type WaterUnitPref = 'ml' | 'fl_oz';

const STORAGE_KEY = 'preformiq_water_unit';

export function mlToFlOz(ml: number): number {
  return ml / ML_PER_US_FLOZ;
}

export function flOzToMl(flOz: number): number {
  return flOz * ML_PER_US_FLOZ;
}

export function roundMl(n: number): number {
  return Math.round(Math.max(0, n));
}

export function getWaterUnitPref(): WaterUnitPref {
  try {
    const v = localStorage.getItem(STORAGE_KEY);
    return v === 'fl_oz' ? 'fl_oz' : 'ml';
  } catch {
    return 'ml';
  }
}

export function setWaterUnitPref(pref: WaterUnitPref): void {
  try {
    localStorage.setItem(STORAGE_KEY, pref);
  } catch {
    /* private mode */
  }
}

function fmtFlOz(ml: number): string {
  const oz = mlToFlOz(ml);
  return oz.toFixed(1).replace(/\.0$/, '');
}

/** Short label for totals and list lines. */
export function formatWaterWithAlt(ml: number, pref: WaterUnitPref): string {
  const m = Math.round(ml);
  if (pref === 'fl_oz') {
    return `${fmtFlOz(ml)} fl oz (${m} ml)`;
  }
  return `${m} ml (~${fmtFlOz(ml)} fl oz)`;
}
